
<mat-card class="grows-to-fill">
  <mat-card-content>
    <!-- Main orders table -->
    <div class="table-container">
      <div class="flex-container-center">
        <div class="flex-item card-header">{{ 'orders.draftOrders' | transloco }}</div>
        <button color="primary" class="flex-item-fixed-size" (click)="onViewAll()" mat-icon-button [attr.aria-label]="'orders.viewAllDraftOrders' | transloco">
          <mat-icon>filter_alt</mat-icon>
        </button>
      </div>

      @if (data.length > 0) {
        <div>
          <!-- Orders table -->
          <app-order-list [data]="this.data" [total]="this.total" [loading]="this.loading" [displayedColumns]="displayedColumns"></app-order-list>
          <!-- End of orders table-->
        </div>
      }
    </div>

    <!-- End of main orders table-->

    @if (!loading && data.length === 0) {
      <div class="spacer-small"></div>
    }
    <lib-placeholder iconName="cancel" iconClass="icon-error" [message]="'orders.errorLoadingDraftOrders' | transloco"
    [condition]="(this.repo.error$ | async) ?? false && !loading"></lib-placeholder>
    <lib-placeholder iconName="check_circle" iconClass="icon-success" [message]="'orders.noDraftOrdersFound' | transloco"
    [condition]="!(this.repo.error$ | async) && !loading && data.length === 0"></lib-placeholder>

  </mat-card-content>
</mat-card>
